import { render, staticRenderFns } from "./GroupBasicBus.vue?vue&type=template&id=4728c27a"
import script from "./GroupBasicBus.vue?vue&type=script&lang=js"
export * from "./GroupBasicBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports